<template>
  <div class="px-5">
    <limit-transaction-agree v-if="isAgree === false" @emitResult="changeAgree" />
    <template v-else>
      <limit-transaction2 v-if="step === 1" @emitResult="nextStep" />
      <limit-transaction v-if="step === 2" @emitResult="nextStep" />
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  components: {
    LimitTransactionAgree: () => import('@/components/documents/LimitTransactionAgree'),
    LimitTransaction: () => import('@/components/documents/LimitTransaction'),
    LimitTransaction2: () => import('@/components/documents/LimitTransaction2'),
  },
  data() {
    return {
      isAgree: false,
      step: 1,
    }
  },
  async created() {
    _meta({
      titles: ['계약서작성'],
    })
  },
  methods: {
    ...mapActions('agreement', ['getContractTerms']),
    ...mapActions('contract', ['getLimitTransaction']),
    ...mapActions('myfinbiz', ['getContractsAgreementsMyfinbizService']),
    changeAgree(v) {
      this.isAgree = v
    },
    async nextStep(v) {
      if (v) {
        this.step += 1
      }
      if (this.step > 2) {
        await this.changeLimitTranaction(v)
      }
    },
    async changeLimitTranaction(v) {
      await this.getLimitTransaction() // 스토어 정보 갱신

      //  정보서비스에서 당겨받기 신청한 경우
      if( this.$route.query.next ) {
        return this.$router.replace(this.$route.query.next)
      }

      // 일반 선정산 유저의 가입 프로세스
      if (v) {
        await this.$router.replace('/apply/before')
      }
    },
  },
}
</script>
